export default __webpack_public_path__ + "static/media/loading_spinner.c35bbacb.gif";